import { useAppDispatch, useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { useInfiniteQuery } from 'react-query';

import { realtorSearchConstants, realtorSearchModels, setSearchVisible, useSearchKeySave } from '..';

export const useFlatRealtorFilter = (
  props: {
    rooms?: string[] | null;
    repaired?: boolean;
    apartment?: boolean;
    minArea?: number | null;
    maxArea?: number | null;
    category?: number;
    ignoreFlatIds?: number[];
    floors?: number[];
    searchKeys?: realtorSearchModels.ISearch[];
  } = {}
) => {
  const dispatch = useAppDispatch();
  const saveKey = useSearchKeySave();
  const searchVisible = useAppSelector(({ realtorSearchReducer }) => realtorSearchReducer.searchVisible);

  return useInfiniteQuery<realtorSearchModels.IFlatRealtorFIlter[]>({
    queryKey: [realtorSearchConstants.queryKeys.FLAT_REALTOR_FILTER, props],
    queryFn: async ({ pageParam }) => {
      const res = await $api.post('/v1/flat/realtor/filter', { page: 1, size: 10, ignoreFlatIds: pageParam, ...props });

      return res.data.data;
    },
    getNextPageParam: (lastPage, page) => {
      if (lastPage?.length >= 10) {
        return page?.reduce<number[]>((p, c) => [...(p || []), ...c?.map(item => item?.id)], []) || [];
      }
      return undefined;
    },
    onSuccess(data) {
      if (
        searchVisible &&
        data?.pages &&
        data?.pages?.length > 0 &&
        data?.pages[0][0] &&
        props?.searchKeys &&
        props?.searchKeys?.length > 0
      ) {
        dispatch(setSearchVisible(false));

        saveKey.mutate(props?.searchKeys[props?.searchKeys?.length - 1]);
      }
    }
  });
};
